import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Chart from "react-apexcharts";
import { React, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export default function SeeDetailModal(params) {
  const selectedID = params.selectedID;
  const customerName = params.customerName;
  const [open, setOpen] = useState(false);
  const state = useSelector((store) => store.analyze);
  const { modificationsData, modificationsPeriods } = state;

  let { lstAnalyzePopupChartData } = modificationsData;
  let rows = getAnalyzePopupTableData(lstAnalyzePopupChartData);

  function getAnalyzePopupTableData(data) {
    let tableData = [];

    let popupChartData = data.filter((x) => x.customerId == selectedID);

    for (let i = 0; i < popupChartData.length; i++) {
      tableData.push(
        popupChartData[i].period,
        popupChartData[i].quota,
        popupChartData[i].increase,
        popupChartData[i].decrease
      );
    }

    let resultData = transposeData(tableData);
    return resultData;
  }

  // Function to convert the array into a transposed format
  function transposeData(dataArray) {
    const transposedData = {
      months: [],
      increase: [],
      decrease: [],
    };

    for (let i = 0; i < dataArray.length; i += 4) {
      transposedData.months.push(dataArray[i]);
      transposedData.increase.push(dataArray[i + 2]);
      transposedData.decrease.push(dataArray[i + 3]);

      // Quota is omitted
    }

    return transposedData;
  }

  let analyzePopupChartData = getAnalyzePopupChartData(
    lstAnalyzePopupChartData
  );

  function getAnalyzePopupChartData(data) {
    let seriesData = [];

    let popupChartData = data.filter((x) => x.customerId == selectedID);

    for (let i = 0; i < popupChartData.length; i++) {
      seriesData.push(
        popupChartData[i].quota,
        popupChartData[i].increase,
        popupChartData[i].decrease
      );
    }

    let resultData = convertToSeries(seriesData);
    return resultData;
  }

  // Function to convert the array into the series format
  function convertToSeries(dataArray) {
    let series = [
      { name: "Decrease", data: [] },
      { name: "Increase", data: [] },
      { name: "Quota", data: [] },
    ];

    for (let i = 0; i < dataArray.length; i += 3) {
      series[0].data.push(dataArray[i + 2]);
      series[1].data.push(dataArray[i + 1]);
      series[2].data.push(dataArray[i]);
    }

    return series;
  }

  const options = {
    title: {
      text: customerName,
      align: "left",
    },
    tooltip: {
			y: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
    xaxis: {
      categories: [...modificationsPeriods],
    },
    yaxis: {
			labels: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
    chart: {
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    stroke: {
      width: 3,
    },
    markers: {
      size: 5,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        borderRadiusApplication: "end", // 'around', 'end'
        borderRadiusWhenStacked: "last", // 'all', 'last'
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
            formatter: (value) => {
              const formatter = new Intl.NumberFormat("en-US");
              return formatter.format(value);
            },
          },
        },
      },
    },

    colors: ["#238823", "#D2222D", "#FFBF00"],
    legend: {
      position: "right",
      horizontalAlign: "left",
      offsetX: -15,
      fontWeight: "bold",
      showForSingleSeries: true,
      maxItems: 2, // Restrict the number of legends to 5
      itemMargin: {
        vertical: 3, // Adjust the vertical margin between legend items
      },
    },
    fill: {
      opacity: 1,
    },
  };

  const series = [...analyzePopupChartData];

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Link sx={{ cursor: "pointer" }} onClick={handleClick}>
        See Details
      </Link>
      <Dialog maxWidth="md" fullWidth open={open} onClose={handleClose}>
        <DialogTitle id="responsive-dialog-title">
          Modification Details
        </DialogTitle>
        <DialogContent>
          <Box className={"columnChart"}>
            <Chart
              options={options}
              series={series}
              type="bar"
              height={500}
              width={"100%"}
            />

            <TableContainer mt={4} component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="transposed table">
                <TableHead>
                  <TableRow>
                    <TableCell>Category</TableCell>
                    {rows.months.map((month, index) => (
                      <TableCell key={index} align="right">
                        {month}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Increase
                    </TableCell>
                    {rows.increase.map((value, index) => (
                      <TableCell key={index} align="right">
                        {value?.toLocaleString('en-US')}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Decrease
                    </TableCell>
                    {rows.decrease.map((value, index) => (
                      <TableCell key={index} align="right">
                        {value?.toLocaleString('en-US')}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
